import { render } from "./HeroiconsSolidThumbDown.vue?vue&type=template&id=0f6e73d4"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidThumbDown.vue"]])

export default __exports__